import React from 'react'
import CreateEditEmailTemplateModal from './CreateEditEmailTemplateModal'
import { CreateNotificationOrSmsModal } from './CreateNotificationOrSmsModal'

export const CommunicationsModal = ({
  openModal,
  controlModal,
  cityId,
  cityEmail,
  userEmail,
  onTemplateSubmit,
  commId,
  actionId,
  commType,
}) => {
  if (commType === 'email')
    return (
      <CreateEditEmailTemplateModal
        open={openModal}
        controlModal={controlModal}
        cityId={cityId}
        cityEmail={cityEmail}
        userEmail={userEmail}
        onSubmit={onTemplateSubmit}
        emailId={commId}
        actionId={actionId}
      />
    )
  if (commType === 'sms' || commType === 'notification')
    return (
      <CreateNotificationOrSmsModal
        open={openModal}
        controlModal={controlModal}
        cityId={cityId}
        commId={commId}
        onSubmit={onTemplateSubmit}
        commType={commType}
      />
    )

  return <React.Fragment />
}
